import axios from "axios";

const axiosInstance = axios.create({
  // DEV
  // baseURL: "http://localhost:8989/plataformas-digitais/api/v1",

  // PROD
  baseURL: "https://digitais.conecta.gov.mz/api/v1",

  // TEST
  // baseURL: "https://platdigitais.ologa.com/api/v1",

  headers: {
    "Content-type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem("principal");
    if (user) {
      config.headers.Authorization = `Bearer ${JSON.parse(user).accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
